import { render, staticRenderFns } from "./FolderCreateModal.vue?vue&type=template&id=c2a8250a&scoped=true"
import script from "./FolderCreateModal.vue?vue&type=script&lang=ts"
export * from "./FolderCreateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a8250a",
  null
  
)

export default component.exports